export default "__VITE_ASSET__DsiCi45V__"